:host(:not([auto-color])) {
  /**
  * @prop --icon-color: Color of the icon (sets the SVG's `fill` property)
  */
  svg {
    * {
      fill: var(--icon-color) !important;
    }
  }

  //Composed icons colors
  path.icons01 {
    fill: var(--icons01-enabled);
  }
  path.icons02 {
    fill: var(--icons02-enabled);
  }
  path.icons03 {
    fill: var(--icons03-enabled);
  }
  path.icons04 {
    fill: var(--icons04-enabled);
  }
  path.icons05 {
    fill: var(--icons05-enabled);
  }
  path.icons06 {
    fill: var(--icons06-enabled);
  }
  path.icons07 {
    fill: var(--icons07-enabled);
  }
  path.icons08 {
    fill: var(--icons08-enabled);
  }
  path.icons09 {
    fill: var(--icons09-enabled);
  }
}
:host {
  /**
  * @prop --icon-size: Size of the icon (sets both width and height)
  */
  display: inline-flex;
  svg {
    width: var(--icon-size);
    height: var(--icon-size);
  }
  line-height: 0;
}
